/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 *
 *  - NULL_VALUE: Null value.
 * @default "NULL_VALUE"
 */
export enum ProtobufNullValue {
  NULL_VALUE = "NULL_VALUE",
}

export interface GetEventsBySessionResponseEvent {
  eventId?: string;
  eventName?: string;
  ip?: string;
  date?: string;
  timestamp?: string;
  json?: string;
}

export interface GetQueriesResponseSaveQuery {
  /** @format int32 */
  id?: number;
  title?: string;
  description?: string;
  /** GetEventsRequest is the Discover search request and the SearchParam shape. */
  query?: V1GetEventsRequest;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface CommonCursorMetadata {
  next?: string;
  prev?: string;
}

export interface CommonPagingMetadata {
  /** @format int64 */
  currentPage?: number;
  /** @format int64 */
  pageSize?: number;
  /** @format int64 */
  totalItems?: number;
  /** @format int64 */
  totalPages?: number;
}

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *     // or ...
 *     if (any.isSameTypeAs(Foo.getDefaultInstance())) {
 *       foo = any.unpack(Foo.getDefaultInstance());
 *     }
 *
 *  Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 *  Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export interface ProtobufAny {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com. As of May 2023, there are no widely used type server
   * implementations and no plans to implement one.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  "@type"?: string;
  [key: string]: any;
}

export interface RpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

/** AcknowledgeAlertResponse ... */
export interface V1AcknowledgeAlertResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of AcknowledgeAlertResponse. */
  data?: V1AcknowledgeAlertResponseData;
}

/** Data is the payload of AcknowledgeAlertResponse. */
export interface V1AcknowledgeAlertResponseData {
  /** @format int64 */
  instanceId?: string;
  status?: string;
  /** @format date-time */
  acknowledgedAt?: string;
  acknowledgedBy?: string;
}

/** Alert is the list-view projection of an alert rule (api.md §1.3). */
export interface V1Alert {
  /** @format int64 */
  alertId?: string;
  appId?: string;
  name?: string;
  description?: string;
  operator?: string;
  /** @format double */
  thresholdValue?: number;
  /** @format int32 */
  evalIntervalSeconds?: number;
  /** @format int32 */
  forDurationSeconds?: number;
  /** @format int32 */
  notifyRepeatIntervalSeconds?: number;
  evalStatus?: string;
  isEnabled?: boolean;
  /** @format date-time */
  lastEvalAt?: string;
  lastError?: string;
  /** @format int64 */
  channelId?: string;
  channelName?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
}

/** AlertInstance is one firing of a rule (api.md §1.4 instances[]). */
export interface V1AlertInstance {
  /** @format int64 */
  instanceId?: string;
  status?: string;
  /** @format date-time */
  firedAt?: string;
  /** @format date-time */
  acknowledgedAt?: string;
  acknowledgedBy?: string;
  ackNote?: string;
  /** @format date-time */
  resolvedAt?: string;
  /** @format double */
  evalResultValue?: number;
  operator?: string;
  /** @format double */
  thresholdValue?: number;
  evalError?: string;
}

/** Channel is the list-view projection of a notification channel (api.md §2.3). */
export interface V1Channel {
  /** @format int64 */
  channelId?: string;
  appId?: string;
  name?: string;
  description?: string;
  webhookUrlMasked?: string;
  isVerified?: boolean;
  /** @format date-time */
  lastTestedAt?: string;
  lastError?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
}

export interface V1Column {
  name?: string;
  type?: string;
}

/** Condition is one filter clause of a Discover search. */
export interface V1Condition {
  column?: string;
  operator?: string;
  value?: string;
  disabled?: boolean;
}

/** DeleteAlertResponse ... */
export interface V1DeleteAlertResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of DeleteAlertResponse. */
  data?: V1DeleteAlertResponseData;
}

/** Data is the payload of DeleteAlertResponse. */
export interface V1DeleteAlertResponseData {
  /** @format int64 */
  alertId?: string;
  /** @format date-time */
  deletedAt?: string;
}

/** DeleteChannelResponse ... */
export interface V1DeleteChannelResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of DeleteChannelResponse. */
  data?: V1DeleteChannelResponseData;
}

/** Data is the payload of DeleteChannelResponse. */
export interface V1DeleteChannelResponseData {
  /** @format int64 */
  channelId?: string;
  /** @format date-time */
  deletedAt?: string;
}

/**
 * FilterGroup is one node of the nested filter tree (T-018a): conditions and
 * subgroups combined with one relation. Nesting is capped server-side (10 levels).
 */
export interface V1FilterGroup {
  /** AND or OR; empty means AND. */
  relation?: string;
  conditions?: V1Condition[];
  groups?: V1FilterGroup[];
}

export interface V1GetActiveColumnsRequest {
  appIds?: string[];
}

export interface V1GetActiveColumnsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetActiveColumnsResponseData;
}

export interface V1GetActiveColumnsResponseData {
  schemaColumns?: V1Column[];
  jsonColumns?: V1Column[];
}

/** GetAlertDetailsResponse ... */
export interface V1GetAlertDetailsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of GetAlertDetailsResponse. */
  data?: V1GetAlertDetailsResponseData;
}

/** Data is the payload of GetAlertDetailsResponse. */
export interface V1GetAlertDetailsResponseData {
  /** @format int64 */
  alertId?: string;
  appId?: string;
  name?: string;
  description?: string;
  /** GetEventsRequest is the Discover search request and the SearchParam shape. */
  queryDefinition?: V1GetEventsRequest;
  /** @format int32 */
  savedQueryId?: number;
  operator?: string;
  /** @format double */
  thresholdValue?: number;
  /** @format int32 */
  evalIntervalSeconds?: number;
  /** @format int32 */
  forDurationSeconds?: number;
  /** @format int32 */
  notifyRepeatIntervalSeconds?: number;
  evalStatus?: string;
  isEnabled?: boolean;
  /** @format date-time */
  lastEvalAt?: string;
  lastError?: string;
  /** @format int64 */
  channelId?: string;
  channelName?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string;
  instances?: V1AlertInstance[];
  /** @format int64 */
  instancesTotal?: string;
}

/** GetChannelDetailsResponse ... */
export interface V1GetChannelDetailsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of GetChannelDetailsResponse. */
  data?: V1GetChannelDetailsResponseData;
}

/** Data is the payload of GetChannelDetailsResponse. */
export interface V1GetChannelDetailsResponseData {
  /** @format int64 */
  channelId?: string;
  appId?: string;
  name?: string;
  description?: string;
  webhookUrlMasked?: string;
  isVerified?: boolean;
  /** @format date-time */
  lastTestedAt?: string;
  lastError?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string;
  /**
   * alert_count / alert_names are the live alerts referencing this channel —
   * what the deletion guard (api.md §2.5) would block on.
   * @format int64
   */
  alertCount?: string;
  alertNames?: string[];
}

export interface V1GetColumnStatisticRequest {
  columnName?: string;
  appIds?: string[];
  /** @format int64 */
  from?: string;
  /** @format int64 */
  to?: string;
  relation?: string;
  conditions?: V1Condition[];
  /** Nested filter tree; when set, replaces relation + conditions. */
  filter?: V1FilterGroup;
}

export interface V1GetColumnStatisticResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetColumnStatisticResponseData;
}

export interface V1GetColumnStatisticResponseData {
  items?: V1GetColumnStatisticResponseItem[];
  /** @format uint64 */
  total?: string;
}

export interface V1GetColumnStatisticResponseItem {
  value?: string;
  /** @format int64 */
  count?: number;
}

export interface V1GetEventResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetEventResponseData;
}

export interface V1GetEventResponseData {
  json?: string;
}

export interface V1GetEventSeriesRequest {
  appIds?: string[];
  /** @format int64 */
  from?: string;
  /** @format int64 */
  to?: string;
  relation?: string;
  conditions?: V1Condition[];
  groupBy?: string;
  /** Nested filter tree; when set, replaces relation + conditions. */
  filter?: V1FilterGroup;
}

export interface V1GetEventSeriesResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetEventSeriesResponseData;
}

export interface V1GetEventSeriesResponseData {
  items?: V1GetEventSeriesResponseItem[];
  /** @format uint64 */
  total?: string;
  groupBy?: string;
}

export interface V1GetEventSeriesResponseItem {
  /** @format uint64 */
  count?: string;
  series?: string;
}

export interface V1GetEventsBySessionResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetEventsBySessionResponseData;
}

export interface V1GetEventsBySessionResponseData {
  events?: GetEventsBySessionResponseEvent[];
  offset?: string;
}

/** GetEventsRequest is the Discover search request and the SearchParam shape. */
export interface V1GetEventsRequest {
  appIds?: string[];
  /** @format int64 */
  from?: string;
  /** @format int64 */
  to?: string;
  columns?: string[];
  relation?: string;
  conditions?: V1Condition[];
  cursor?: string;
  /** @format int32 */
  limit?: number;
  relativeFrom?: string;
  relativeTo?: string;
  /**
   * Nested filter tree; when set, replaces the flat relation + conditions
   * pair (kept for backward compat).
   */
  filter?: V1FilterGroup;
}

export interface V1GetEventsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetEventsResponseData;
}

export interface V1GetEventsResponseData {
  data?: object[];
  cursor?: CommonCursorMetadata;
}

export interface V1GetInvalidEventsRequest {
  appIds?: string[];
  range?: string;
}

export interface V1GetInvalidEventsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetInvalidEventsResponseData[];
}

export interface V1GetInvalidEventsResponseData {
  appId?: string;
  eventName?: string;
  screenName?: string;
  reason?: string;
  /** @format uint64 */
  count?: string;
}

/** GetListAlertResponse ... */
export interface V1GetListAlertResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of GetListAlertResponse. */
  data?: V1GetListAlertResponseData;
}

/** Data is the payload of GetListAlertResponse. */
export interface V1GetListAlertResponseData {
  alerts?: V1Alert[];
  /** @format int64 */
  total?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  offset?: number;
}

/** GetListChannelResponse ... */
export interface V1GetListChannelResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of GetListChannelResponse. */
  data?: V1GetListChannelResponseData;
}

/** Data is the payload of GetListChannelResponse. */
export interface V1GetListChannelResponseData {
  channels?: V1Channel[];
  /** @format int64 */
  total?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  offset?: number;
}

export interface V1GetQueriesResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetQueriesResponseData;
}

export interface V1GetQueriesResponseData {
  data?: GetQueriesResponseSaveQuery[];
  paging?: CommonPagingMetadata;
}

export interface V1GetQueryByShortCodeResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** GetEventsRequest is the Discover search request and the SearchParam shape. */
  data?: V1GetEventsRequest;
}

export interface V1GetQueryResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1SaveQueryRequest;
}

export interface V1GetSuggestionsRequest {
  columnName?: string;
  appIds?: string[];
  quest?: string;
  /** @format int64 */
  from?: string;
  /** @format int64 */
  to?: string;
}

export interface V1GetSuggestionsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetSuggestionsResponseData;
}

export interface V1GetSuggestionsResponseData {
  items?: V1GetSuggestionsResponseItem[];
}

export interface V1GetSuggestionsResponseItem {
  value?: string;
  /** @format int64 */
  count?: number;
}

export interface V1GetSurroundingEventsRequest {
  /**
   * Single app: the anchor event belongs to exactly one of them, and the
   * surrounding rows are only meaningful inside that app's stream.
   */
  appId?: string;
  /**
   * Unix seconds. The centre of the window.
   * @format int64
   */
  anchorTime?: string;
  /**
   * event_id of the anchor row, optional but strongly recommended.
   *
   * timestamp has one-second resolution, so on a busy app the anchor's own
   * second can hold more rows than `limit`. Without this the two sides are cut
   * at the second boundary alone: the anchor row itself can fall outside the
   * page and the panel has nothing to highlight. Given it, the split is
   * (timestamp, event_id) — the same tiebreak the GetEvents cursor uses — and
   * the anchor is always the first row of the newer side.
   */
  anchorEventId?: string;
  /**
   * Window half-widths in seconds. 0 means the server default (120s each) —
   * proto3 cannot tell an unset field from a zero, so a side cannot be asked
   * to be zero-width. Nothing needs that today; if the panel ever does, these
   * become wrapper types before the contract ships.
   * Their sum is capped server-side so the query can never turn into a scan.
   * @format int32
   */
  windowBeforeSeconds?: number;
  /** @format int32 */
  windowAfterSeconds?: number;
  /**
   * Max events per side, not in total: the response can hold up to 2 * limit
   * rows. 0 means the server default.
   * @format int32
   */
  limit?: number;
  /**
   * Same select list and filters as GetEvents, so the panel shows the columns
   * the user already picked on Discover.
   */
  columns?: string[];
  relation?: string;
  conditions?: V1Condition[];
  /** Nested filter tree; when set, replaces relation + conditions. */
  filter?: V1FilterGroup;
}

export interface V1GetSurroundingEventsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetSurroundingEventsResponseData;
}

export interface V1GetSurroundingEventsResponseData {
  /**
   * Ascending by (timestamp, event_id) — oldest first — so the panel renders
   * the list top to bottom without re-sorting.
   */
  data?: object[];
  /**
   * The window actually applied, after defaults and clamping. The panel shows
   * it and uses it as the base for an expand action.
   * @format int64
   */
  from?: string;
  /** @format int64 */
  to?: string;
}

export interface V1GetUserSessionsResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1GetUserSessionsResponseData;
}

export interface V1GetUserSessionsResponseData {
  sessions?: V1Session[];
  offset?: string;
}

/** InsertAlertRequest creates an alert rule from a Discover search (api.md §1.1). */
export interface V1InsertAlertRequest {
  appId?: string;
  name?: string;
  description?: string;
  /**
   * query_definition is the SearchParam snapshot the worker evaluates. It is
   * the existing saved-query shape (GetEventsRequest) and is immutable after
   * creation (TDD R-05).
   */
  queryDefinition?: V1GetEventsRequest;
  /**
   * saved_query_id is provenance only — queries.id of the source saved query.
   * Not checked for existence, no cascade (TDD R-05).
   * @format int32
   */
  savedQueryId?: number;
  operator?: string;
  /**
   * threshold_value is mandatory; a wrapper so that "missing" and 0 differ.
   * @format double
   */
  thresholdValue?: number;
  /** @format int32 */
  evalIntervalSeconds?: number;
  /** @format int32 */
  forDurationSeconds?: number;
  /** @format int64 */
  channelId?: string;
  /**
   * notify_repeat_interval_seconds: 0 means "use the guardrail default".
   * @format int32
   */
  notifyRepeatIntervalSeconds?: number;
}

/** InsertAlertResponse ... */
export interface V1InsertAlertResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of InsertAlertResponse. */
  data?: V1InsertAlertResponseData;
}

/** Data is the payload of InsertAlertResponse. */
export interface V1InsertAlertResponseData {
  /** @format int64 */
  alertId?: string;
  name?: string;
  evalStatus?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
}

/** InsertChannelRequest creates a channel (api.md §2.1). */
export interface V1InsertChannelRequest {
  appId?: string;
  name?: string;
  description?: string;
  /**
   * webhook_url must be a Google Chat incoming webhook
   * (https://chat.googleapis.com/v1/spaces/…); validated on the plaintext
   * before encryption.
   */
  webhookUrl?: string;
}

/** InsertChannelResponse ... */
export interface V1InsertChannelResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of InsertChannelResponse. */
  data?: V1InsertChannelResponseData;
}

/** Data is the payload of InsertChannelResponse. */
export interface V1InsertChannelResponseData {
  /** @format int64 */
  channelId?: string;
  appId?: string;
  name?: string;
  isVerified?: boolean;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string;
}

export interface V1SaveQueryRequest {
  /** @format int32 */
  id?: number;
  title?: string;
  description?: string;
  /** GetEventsRequest is the Discover search request and the SearchParam shape. */
  query?: V1GetEventsRequest;
  withShortLink?: boolean;
}

export interface V1SaveQueryResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  data?: V1SaveQueryResponseData;
}

export interface V1SaveQueryResponseData {
  /** @format int32 */
  id?: number;
  path?: string;
}

export interface V1Session {
  id?: string;
  /** @format int64 */
  createdAt?: string;
}

/** TestChannelResponse ... */
export interface V1TestChannelResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of TestChannelResponse. */
  data?: V1TestChannelResponseData;
}

/** Data is the payload of TestChannelResponse. */
export interface V1TestChannelResponseData {
  /** @format int64 */
  channelId?: string;
  isVerified?: boolean;
  /** @format date-time */
  lastTestedAt?: string;
  messagePosted?: boolean;
}

/** UpdateAlertResponse ... */
export interface V1UpdateAlertResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of UpdateAlertResponse. */
  data?: V1UpdateAlertResponseData;
}

/** Data is the payload of UpdateAlertResponse. */
export interface V1UpdateAlertResponseData {
  /** @format int64 */
  alertId?: string;
  name?: string;
  /** @format double */
  thresholdValue?: number;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string;
}

/** UpdateChannelResponse ... */
export interface V1UpdateChannelResponse {
  /** @format int64 */
  code?: number;
  message?: string;
  /** Data is the payload of UpdateChannelResponse. */
  data?: V1UpdateChannelResponseData;
}

/** Data is the payload of UpdateChannelResponse. */
export interface V1UpdateChannelResponseData {
  /** @format int64 */
  channelId?: string;
  name?: string;
  isVerified?: boolean;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title tracking/v1/tracking.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingAcknowledgeAlert
     * @request POST:/api/v1/alert-instances/{instanceId}/acknowledge
     */
    trackingAcknowledgeAlert: (
      instanceId: string,
      body: {
        appId?: string;
        note?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1AcknowledgeAlertResponse, RpcStatus>({
        path: `/api/v1/alert-instances/${instanceId}/acknowledge`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetListAlert
     * @summary Alert CRUD — READ
     * @request GET:/api/v1/alerts
     */
    trackingGetListAlert: (
      query?: {
        appId?: string;
        /** eval_status filters by OK | PENDING | ALERTING; empty returns all. */
        evalStatus?: string;
        /** enabled is tri-state: unset returns both enabled and disabled alerts. */
        enabled?: boolean;
        /** @format int32 */
        limit?: number;
        /** @format int32 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetListAlertResponse, RpcStatus>({
        path: `/api/v1/alerts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingInsertAlert
     * @summary Alert CRUD — WRITE
     * @request POST:/api/v1/alerts
     */
    trackingInsertAlert: (
      body: V1InsertAlertRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1InsertAlertResponse, RpcStatus>({
        path: `/api/v1/alerts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetAlertDetails
     * @request GET:/api/v1/alerts/{alertId}
     */
    trackingGetAlertDetails: (
      alertId: string,
      query?: {
        appId?: string;
        /** include_instances defaults to true when unset. */
        includeInstances?: boolean;
        /** @format int32 */
        instanceLimit?: number;
        /** @format int32 */
        instanceOffset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetAlertDetailsResponse, RpcStatus>({
        path: `/api/v1/alerts/${alertId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingDeleteAlert
     * @request DELETE:/api/v1/alerts/{alertId}
     */
    trackingDeleteAlert: (
      alertId: string,
      query?: {
        appId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DeleteAlertResponse, RpcStatus>({
        path: `/api/v1/alerts/${alertId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingUpdateAlert
     * @request PUT:/api/v1/alerts/{alertId}
     */
    trackingUpdateAlert: (
      alertId: string,
      body: {
        appId?: string;
        name?: string;
        description?: string;
        operator?: string;
        /** @format double */
        thresholdValue?: number;
        /** @format int32 */
        evalIntervalSeconds?: number;
        /** @format int32 */
        forDurationSeconds?: number;
        /** @format int64 */
        channelId?: string;
        /** @format int32 */
        notifyRepeatIntervalSeconds?: number;
        isEnabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1UpdateAlertResponse, RpcStatus>({
        path: `/api/v1/alerts/${alertId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetListChannel
     * @summary Channel CRUD — READ
     * @request GET:/api/v1/channels
     */
    trackingGetListChannel: (
      query?: {
        appId?: string;
        /** @format int32 */
        limit?: number;
        /** @format int32 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetListChannelResponse, RpcStatus>({
        path: `/api/v1/channels`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingInsertChannel
     * @summary Channel CRUD — WRITE
     * @request POST:/api/v1/channels
     */
    trackingInsertChannel: (
      body: V1InsertChannelRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1InsertChannelResponse, RpcStatus>({
        path: `/api/v1/channels`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetChannelDetails
     * @request GET:/api/v1/channels/{channelId}
     */
    trackingGetChannelDetails: (
      channelId: string,
      query?: {
        appId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetChannelDetailsResponse, RpcStatus>({
        path: `/api/v1/channels/${channelId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingDeleteChannel
     * @request DELETE:/api/v1/channels/{channelId}
     */
    trackingDeleteChannel: (
      channelId: string,
      query?: {
        appId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DeleteChannelResponse, RpcStatus>({
        path: `/api/v1/channels/${channelId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingUpdateChannel
     * @request PUT:/api/v1/channels/{channelId}
     */
    trackingUpdateChannel: (
      channelId: string,
      body: {
        appId?: string;
        name?: string;
        description?: string;
        webhookUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1UpdateChannelResponse, RpcStatus>({
        path: `/api/v1/channels/${channelId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingTestChannel
     * @request POST:/api/v1/channels/{channelId}/test
     */
    trackingTestChannel: (
      channelId: string,
      body: {
        appId?: string;
        testMessage?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1TestChannelResponse, RpcStatus>({
        path: `/api/v1/channels/${channelId}/test`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetActiveColumns
     * @request POST:/api/v1/columns
     */
    trackingGetActiveColumns: (
      body: V1GetActiveColumnsRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetActiveColumnsResponse, RpcStatus>({
        path: `/api/v1/columns`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetColumnStatistic
     * @request POST:/api/v1/columns/statistic
     */
    trackingGetColumnStatistic: (
      body: V1GetColumnStatisticRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetColumnStatisticResponse, RpcStatus>({
        path: `/api/v1/columns/statistic`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetSuggestions
     * @request POST:/api/v1/columns/suggestions
     */
    trackingGetSuggestions: (
      body: V1GetSuggestionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetSuggestionsResponse, RpcStatus>({
        path: `/api/v1/columns/suggestions`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetEventSeries
     * @request POST:/api/v1/event-series
     */
    trackingGetEventSeries: (
      body: V1GetEventSeriesRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetEventSeriesResponse, RpcStatus>({
        path: `/api/v1/event-series`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetEvents
     * @request POST:/api/v1/events
     */
    trackingGetEvents: (body: V1GetEventsRequest, params: RequestParams = {}) =>
      this.request<V1GetEventsResponse, RpcStatus>({
        path: `/api/v1/events`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description POST, not GET, because the panel replays the caller's Discover filters and a repeated Condition message cannot be expressed as query parameters.
     *
     * @tags Tracking
     * @name TrackingGetSurroundingEvents
     * @summary GetSurroundingEvents returns the events around an anchor point in time, for the Discover "surrounding documents" panel (T-017).
     * @request POST:/api/v1/events/surrounding
     */
    trackingGetSurroundingEvents: (
      body: V1GetSurroundingEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetSurroundingEventsResponse, RpcStatus>({
        path: `/api/v1/events/surrounding`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetEvent
     * @request POST:/api/v1/events/{eventId}
     */
    trackingGetEvent: (
      eventId: string,
      body: {
        appIds?: string[];
        date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetEventResponse, RpcStatus>({
        path: `/api/v1/events/${eventId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetInvalidEvents
     * @request POST:/api/v1/invalid-events
     */
    trackingGetInvalidEvents: (
      body: V1GetInvalidEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<V1GetInvalidEventsResponse, RpcStatus>({
        path: `/api/v1/invalid-events`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetQueries
     * @request GET:/api/v1/queries
     */
    trackingGetQueries: (
      query?: {
        /** @format int64 */
        pageNum?: number;
        /** @format int64 */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetQueriesResponse, RpcStatus>({
        path: `/api/v1/queries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingSaveQuery
     * @request POST:/api/v1/queries
     */
    trackingSaveQuery: (body: V1SaveQueryRequest, params: RequestParams = {}) =>
      this.request<V1SaveQueryResponse, RpcStatus>({
        path: `/api/v1/queries`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetQuery
     * @request GET:/api/v1/queries/{id}
     */
    trackingGetQuery: (id: number, params: RequestParams = {}) =>
      this.request<V1GetQueryResponse, RpcStatus>({
        path: `/api/v1/queries/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetUserSessions
     * @request GET:/api/v1/sessions
     */
    trackingGetUserSessions: (
      query?: {
        appId?: string;
        userId?: string;
        /** @format int64 */
        from?: string;
        /** @format int64 */
        to?: string;
        /** @format int32 */
        limit?: number;
        offset?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetUserSessionsResponse, RpcStatus>({
        path: `/api/v1/sessions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetEventsBySession
     * @request GET:/api/v1/sessions/{sessionId}/events
     */
    trackingGetEventsBySession: (
      sessionId: string,
      query?: {
        appId?: string;
        /** @format int32 */
        limit?: number;
        offset?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetEventsBySessionResponse, RpcStatus>({
        path: `/api/v1/sessions/${sessionId}/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name TrackingGetQueryByShortCode
     * @request GET:/api/v1/short/{shortCode}
     */
    trackingGetQueryByShortCode: (
      shortCode: string,
      params: RequestParams = {},
    ) =>
      this.request<V1GetQueryByShortCodeResponse, RpcStatus>({
        path: `/api/v1/short/${shortCode}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
